import React from "react";
import "../scss/Rates.scss";
import refresh from "../Images/refresh.png";
import btc from "../Images/btc.png";
import arrow_one from "../Images/arrow-one.png";
import arrow_two from "../Images/arrow-two.png";
import BidsCard from "../components/BidsCard";

const RatesPage = () => {
	return (
		<div className="rates">
			<div className="rates__container">
				<div className="rates__heroContainer">
					<div className="rates__hero">
						<p className="rates__heading">
							Get Informed, <span>Stay Relevant, </span>Plan Better!
						</p>

						<div className="rates__hero__commodity">
							<div className="rates__hero__commodityTop">
								<div className="rates__hero__commodityLeft">
									<p>Commodity you are changing from</p>
									<div className="rates__hero__selection">
										<input type="number" name="" id="" value="0.1" />
										<img src={btc} alt="" />
										<select>
											<option value="USD">USD</option>
											<option value="EUR">EUR</option>
										</select>
									</div>
								</div>
								<img src={refresh} alt="refresh" />
								<div className="rates__hero__commodityRight">
									<p>Commodity you are changing to</p>
									<div className="rates__hero__selection">
										<input type="number" name="" id="" value="0.1" />
										<img src={btc} alt="" />
										<select>
											<option value="EUR">EUR</option>
											<option value="USD">USD</option>
										</select>
									</div>
								</div>
							</div>

							<div className="rates__hero__commodityBottom">
								<button className="homepage__conversion__buy">
									BUY <img src={arrow_two} alt="" />
								</button>
								<button className="homepage__conversion__sell">
									SELL <img src={arrow_one} alt="" />
								</button>
							</div>
						</div>

						<div className="homepage__bidWrapper">
							<BidsCard />
							<BidsCard />
							<BidsCard />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RatesPage;
